<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
      <span class="icon"><i class="fas fa-plane-departure"></i></span>{{ 'ExportDeclarationQuery.Header' | translate }}</h1>
    <p-card>
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
                <form [formGroup]="searchForm">
                    <div class="p-fluid formgrid grid">
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.ExportDeclarForm' | translate }}</label>
                            <p-chips formControlName="exportDeclarationNo" [(ngModel)]="searchParams.exportDeclarationNo" separator="," (onAdd)="onChipsAdd($event, 'exportDeclarationNo')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label *ngIf="!isHkFacility">{{ 'ExportDeclarationQuery.Search.IdenNum' | translate }}</label>
                            <label *ngIf="isHkFacility">{{ 'ExportDeclarationQuery.Search.HK.IdenNum' | translate }}</label>
                            <p-chips formControlName="docNo" [(ngModel)]="searchParams.docNo" separator="," (onAdd)="onChipsAdd($event, 'docNo')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.InvoiceNum' | translate }}</label>
                            <p-chips formControlName="invoiceNo" [(ngModel)]="searchParams.invoiceNo" separator="," (onAdd)="onChipsAdd($event, 'invoiceNo')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label *ngIf="!isHkFacility">{{ 'ExportDeclarationQuery.Search.OrignalTransactiaonNum' | translate }}</label>
                            <label *ngIf="isHkFacility">{{ 'ExportDeclarationQuery.Search.HK.OrignalTransactiaonNum' | translate }}</label>
                            <p-chips formControlName="doNo" [(ngModel)]="searchParams.doNo" separator="," (onAdd)="onChipsAdd($event, 'doNo')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.CustomerCode' | translate }}</label>
                            <p-chips formControlName="consigneeKey" [(ngModel)]="searchParams.consigneeKey" separator="," (onAdd)="onChipsAdd($event, 'consigneeKey')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.MAWB' | translate }}</label>
                            <p-chips formControlName="mawbNo" [(ngModel)]="searchParams.mawbNo" separator="," (onAdd)="onChipsAdd($event, 'mawbNo')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.HAWB' | translate }}</label>
                            <p-chips formControlName="expressBill" [(ngModel)]="searchParams.expressBill" separator="," (onAdd)="onChipsAdd($event, 'expressBill')"></p-chips>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.Company' | translate }}</label>
                            <p-multiSelect formControlName="orgId" [(ngModel)]="searchParams.orgId" [options]="orgIdOptions"></p-multiSelect>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.MainTable.LetterOrgId' | translate }}</label>
                            <p-multiSelect formControlName="letterOrgId" [(ngModel)]="searchParams.letterOrgId" [options]="orgIdOptions"></p-multiSelect>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.Status' | translate }}</label>
                            <p-multiSelect
                                formControlName="status"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.status"
                                [options]="statusOptions"
                                [filter]="true"
                                filterBy="label"
                            ></p-multiSelect>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                          <div class="mb-1">{{ 'BookingSearch.Form.Forwarder' | translate }}</div>
                          <div class="item">
                              <p-multiSelect formControlName="bookingForwarder" optionLabel="optionDesc" optionValue="optionCode" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.bookingForwarder" [options]="bookingForwarderList" [filter]="true"
                                  filterBy="optionDesc"></p-multiSelect>
                          </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.MainTable.ShipMethod' | translate }}</label>
                            <p-multiSelect
                                formControlName="shipMethod"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.shipMethod"
                                [options]="shipMethodOptions"
                                [filter]="true"
                                filterBy="label"
                            ></p-multiSelect>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 laas-calendar">
                          <laas-calendar
                            #createDt
                            [title]="'ExportDeclarationQuery.Search.CreationTime'"
                            [enableMaxDateIsToday]="false"
                            [showRangeMode]="true"
                            [showStartMode]="true"
                            (onDateChange)="dateOnChange($event,'createDt')">
                          </laas-calendar>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <label>{{ 'ExportDeclarationQuery.Search.Creator' | translate }}</label>
                            <p-chips formControlName="createUser" [(ngModel)]="searchParams.createUser" separator="," (onAdd)="onChipsAdd($event, 'createUser')"></p-chips>
                        </div>
                        <div *ngIf="this.isHkFacility" class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'ExportDeclarationQuery.Search.BookingNo' | translate }}</label>
                            <p-chips formControlName="bookingNo" [(ngModel)]="searchParams.bookingNo" separator="," (onAdd)="onChipsAdd($event, 'bookingNo')"></p-chips>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col" style="margin-top: 0.5rem;">
                            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
                            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-2" (click)="resetBtnClick($event)"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <laas-data-table
                [expandable]="true"
                (rowExpanded)="searchDetailClick($event)"
                [tableKey]="preferenceKey"
                [loading]="isLoading"
                [selectable]="false"
                [dataKey]="'exportDeclarationNo'"
                [value]="exportRows"
                [defaultColumns]="columns"
                (tableOnPage)="tablePageChange($event)"
                (tableOnSort)="tableSort($event)"
                [lazy]="true"
                [rowsPerPageOptions]="[5,10,25,50,100,200]"
            >
                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                    <td *ngFor="let col of columns">
                        <div [ngSwitch]="col.field">
                            <a *ngSwitchCase="'exportDeclarationNo'" href="javascript: void(0);" (click)="exportLinkClick($event, rowData)">{{rowData[col.field]}}</a>
                            <ng-container *ngSwitchCase="'status'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:statusOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'orgId'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'bookingForwarder'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'docType'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:docTypeOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'docType1'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:docType1Options | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'currency'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:currenyOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'docNo'">
                                <div class="overflow-text">
                                    {{rowData[col.field]}}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'toCountry'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:toCountryOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'toCity'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:toCityOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'letterOrgId'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'shipMethod'">
                                <div class="overflow-text">
                                    {{ rowData[col.field] | optionsMapping:shipMethodOptions | replaceNullWith:'-' }}
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <ng-container [ngSwitch]="col.dataType">
                                    <ng-container *ngSwitchCase="'date'">
                                        <div class="overflow-text">
                                            {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <div class="overflow-text">
                                            {{ rowData[col.field] | replaceNullWith:'-'}}
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </div>
                    </td>
                </ng-template>

                <ng-template pTemplate="rowexpansion" let-rowData>
                    <laas-data-table
                        [tableTitle]="formatTableTitle(rowData)"
                        [tableKey]="detailPreferenceKey"
                        [dataKey]="'doNo'"
                        [selectable]="false"
                        [value]="rowData.details"
                        [defaultColumns]="detailColumns"
                        [loading]="isLoading"
                        [paginator]="false"
                        [style]="{ 'overflow-y': 'auto' }"
                    >
                        <ng-template pTemplate="caption">
                            <button class="ml-3" (click)="openImportBtn($event, rowData)" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.Import' | translate }}"></button>
                            <button class="ml-3" (click)="openBillingViewerBtn($event, rowData)" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.BillingViewer' | translate }}"></button>
                            <button class="ml-3" (click)="openBillingFeeBtn($event, rowData)" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.BillingFee' | translate }}"></button>
                            <button class="ml-3" (click)="confirmExportBtn($event, rowData)" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.ConfirmExportDeclar' | translate }}"></button>
                            <button class="ml-3" (click)="deleteExport($event, rowData)" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.CancelExportDeclar' | translate }}"></button>
                            <button class="ml-3" (click)="confirmDeleteBtn($event, rowData)" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.DeleteExportDeclar' | translate }}"></button>
                            <button class="ml-3" (click)="fake($event, rowData)" style="opacity: 0; cursor: default;" pButton pRipple label="{{ 'ExportDeclarationQuery.SubTable.Button.CancelExportDeclar' | translate }}"></button>
                        </ng-template>
                        <ng-template pTemplate="body" let-exportObj let-columns="columns">
                            <td *ngFor="let col of columns">
                                <div [ngSwitch]="col.field">
                                    <ng-container *ngSwitchCase="'__delete'">
                                        <i *ngIf="rowData.status === '0'" class="fas fa-trash" (click)="deleteDetail($event, rowData, exportObj)"></i>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'orgId'">
                                        <div class="overflow-text">
                                            {{ exportObj[col.field] | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'createDt'">
                                        <div class="overflow-text">
                                            {{ exportObj[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'updateDt'">
                                        <div class="overflow-text">
                                            {{ exportObj[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <div class="overflow-text">
                                            {{ exportObj[col.field] | replaceNullWith:'-' }}
                                        </div>
                                    </ng-container>
                                </div>
                            </td>
                        </ng-template>
                        <ng-template pTemplate="footer" let-columns="columns">
                            <tr>
                                <td *ngFor="let col of columns">
                                    <ng-container [ngSwitch]="col.field">
                                        <ng-container *ngSwitchCase="'__delete'">
                                            {{ 'ExportDeclarationQuery.SubTable.Form.TotalAmount' | translate }}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'invoiceAmount'">
                                            {{getTotalAmount(rowData).invoiceAmount}}
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'invoiceNtdAmount'">
                                            {{getTotalAmount(rowData).invoiceNtdAmount}}
                                        </ng-container>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-template>
                    </laas-data-table>
                </ng-template>

                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length + 1" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </laas-data-table>
        </div>
    </p-card>
    <p-dialog header="匯入查詢DO單號" appendTo="body" [(visible)]="isShowImportModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isImportFormOpen">
                <form [formGroup]="invoiceForm">
                    <div class="p-fluid formgrid grid">
                        <div class="field col-6">
                            <label>發票日期</label>
                            <div class="formgrid grid">
                                <div class="col">
                                    <p-calendar formControlName="startDate" [class]="(invoiceSubmitted && f.startDate.errors) ? ['ng-invalid', 'ng-dirty'] : []" [(ngModel)]="searchImportDoParams.startDate" appendTo="body" dateFormat="yy/mm/dd">
                                    </p-calendar>
                                    <small *ngIf="invoiceSubmitted && f.startDate.errors" class="errors">
                                      <div *ngIf="f.startDate.errors.required" class="p-invalid">發票起始日期 is required</div>
                                    </small>
                                </div> ~
                                <div class="col">
                                    <p-calendar formControlName="endDate" [class]="(invoiceSubmitted && f.endDate.errors) ? ['ng-invalid', 'ng-dirty'] : []" [(ngModel)]="searchImportDoParams.endDate" appendTo="body" dateFormat="yy/mm/dd">
                                    </p-calendar>
                                    <small *ngIf="invoiceSubmitted && f.endDate.errors" class="errors">
                                      <div *ngIf="f.endDate.errors.required" class="p-invalid">發票結束日期 is required</div>
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="field col-6">
                            <label>發票號碼</label>
                            <div class="formgrid grid">
                                <div class="col">
                                    <input type="text" pInputText formControlName="invoiceNoStart">
                                </div> ~
                                <div class="col">
                                    <input type="text" pInputText formControlName="invoiceNoEnd">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchImportDoClickBtn($event)"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <p-table class="datatable" [value]="importDos" [(selection)]="doObjs" [loading]="isImportLoding">
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>交貨單號</th>
                        <th>發票號碼</th>
                        <th>發票金額</th>
                        <th>發票金額(台幣)</th>
                        <th>發票日期</th>
                        <th>TrxNumber</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-doObj>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="doObj"></p-tableCheckbox>
                        </td>
                        <td><div class="overflow-text">{{doObj.delivery_NUM}}</div></td>
                        <td><div class="overflow-text">{{doObj.invoice_NUMBER}}</div></td>
                        <td><div class="overflow-text">{{doObj.amount}}</div></td>
                        <td><div class="overflow-text">{{doObj.ntd_AMOUNT}}</div></td>
                        <td><div class="overflow-text">{{doObj.invoice_DATE | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div></td>
                        <td><div class="overflow-text">{{doObj.trx_NUMBER}}</div></td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="7" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="grid">
            <div class="col" style="margin-top: 0.5rem;">
                <button pButton pRipple label="匯入勾選DO單號" (click)="importDoBtnLCick($event)"></button>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="匯入DO單號" appendTo="body" [(visible)]="isShowHKImportModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isImportFormOpen">
                <form [formGroup]="invoiceHKForm">
                    <div class="p-fluid formgrid grid">
                        <div class="ml col-6">
                            <label>{{ 'ExportDeclarationQuery.Search.HK.OrignalTransactiaonNum' | translate }}</label>
                            <div class="formgrid grid">
                                <div class="col-12">
                                    <p-chips formControlName="doNos" separator="," [class]="(invoiceSubmitted && hkf.doNos.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-chips>
                                    <small *ngIf="invoiceSubmitted && hkf.doNos.errors" class="errors">
                                        <div *ngIf="hkf.doNos.errors.required" class="p-invalid">
                                            {{ 'ExportDeclarationQuery.Search.HK.OrignalTransactiaonNum' | translate }} is required
                                        </div>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid" style="margin-top: 0.5rem;">
                        <div class="col">
                            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchImportHKDoClickBtn($event)"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <p-table class="datatable" [value]="importDos" [(selection)]="doObjs" [loading]="isImportLoding">
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>交貨單號</th>
                        <th>發票號碼</th>
                        <th>發票日期</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-doObj>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="doObj"></p-tableCheckbox>
                        </td>
                        <td><div class="overflow-text">{{doObj.delivery_NUM}}</div></td>
                        <td><div class="overflow-text">{{doObj.invoice_NUMBER}}</div></td>
                        <td><div class="overflow-text">{{doObj.invoice_DATE | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div></td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="7" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="grid">
            <div class="col" style="margin-top: 0.5rem;">
                <button pButton pRipple label="匯入勾選DO單號" (click)="importDoBtnLCick($event)"></button>
            </div>
        </div>
    </p-dialog>

    <laas-billing-viewer [display]="isShowBillingViewerModal" [bookingNo]="bookingNoFile" [bookingInfo]="bookingInfo" [feature]="'EX-DECLARATION'" (onClose)="closeBilling($event)"></laas-billing-viewer>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
